import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './CtaButton.css';
export default function CtaButton({isLoading = false, icon, text, onClickCallback}){
    return(
        <>
            <button className={"cta-button " + (isLoading ? "loading" : "")}
                onClick={onClickCallback}>
                <FontAwesomeIcon spin={isLoading} icon={isLoading ? "fa-solid fa-spinner" : icon} /> {!isLoading? text : ""}</button>
        </>
    )
}